import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import setup_45global from "/app/app/middleware/setup.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  setup_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/middleware/auth.ts"),
  "recover-pass": () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/middleware/recover-pass.ts"),
  "redirect-user-zone": () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/middleware/redirect-user-zone.ts")
}